import { getProjectAssetUrl } from "./getProjectAssetUrl";
import { invalidateProjectAssetUrl } from "./invalidateProjectAssetUrl";
import type { FetchProjectAsset } from "./types";

export const fetchProjectAsset: FetchProjectAsset = async ({
  projectId,
  key,
  cache,
}) => {
  const url = await getProjectAssetUrl({ projectId, key });
  // No signed URL means no access path at all — raw S3 is never contacted.
  if (!url) return new Response(null, { status: 404 });

  const response = await fetch(url, cache ? { cache } : undefined);
  if (response.status !== 403) return response;

  // An expired signature 403s; re-sign once and retry. A second 403 is a
  // real access denial and is returned as-is.
  invalidateProjectAssetUrl({ projectId, key });
  const freshUrl = await getProjectAssetUrl({ projectId, key });
  if (!freshUrl) return response;
  return fetch(freshUrl, cache ? { cache } : undefined);
};
